// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const nounPath = (nounId: number) => `/lilnoun/${nounId}`;
